var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadButtonFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2754 17.5H19V18.5H14.5V14H15.5V16.8346C17.7622 15.1237 19 12.7192 19 10C19 5.03735 14.9626 1 10 1V0C15.514 0 20 4.48596 20 10C20 12.9743 18.6848 15.6062 16.2754 17.5ZM1 10C1 7.28075 2.23776 4.87634 4.5 3.16543V6H5.5V1.5H1V2.5H3.72457C1.31522 4.39378 0 7.0257 0 10C0 15.514 4.48596 20 10 20V19C5.03735 19 1 14.9626 1 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadButtonFilter);
export default __webpack_public_path__ + "static/media/reloadButtonFilter.df8881d673d3fa9779ba5dcdee4d441b.svg";
export { ForwardRef as ReactComponent };